// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Td9uN","notes":"Notes_notes__3fPZH","note":"Notes_note__2crxf","markdown":"Notes_markdown__2zMCY"};